import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const ContentGeneratorPage = lazyWithRetry(() => import('./pages/ContentGeneratorPage'))
const ContentOptimizationPage = lazyWithRetry(() => import('./pages/ContentOptimizationPage'))

const routes: AppRoute[] = [
  {
    path: 'content-generator',
    element: ContentGeneratorPage,
    meta: {
      title: 'sidebarNav.contentGenerator',
      require: { minRole: ROLE.MEMBER },
    },
  },
  {
    path: 'content-optimization',
    element: ContentOptimizationPage,
    meta: {
      title: 'sidebarNav.contentOptimization',
      require: { minRole: ROLE.MEMBER },
    },
  },
]

export default routes
